<template>
  <div class="standard-feature-page">
    <div class="standard-feature-layout">
      <!-- 左侧：参数配置 -->
      <div class="standard-side-panel">
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm0 18a7 7 0 1 1 7-7 7 7 0 0 1-7 7z"></path>
                <path d="M12 7v5l3 3"></path>
              </svg>
            </div>
            <span>音频去重调节</span>
            <div class="header-content" style="display: flex; align-items: center; gap: 10px; margin-left: 10px;">
              <span style="font-size: 12px; color: var(--text-secondary);">音效</span>
              <label class="cyber-switch">
                <input type="checkbox" v-model="audioParams.audioEffectsEnabled" @change="toggleAudioEffects">
                <span class="switch-slider"></span>
              </label>
            </div>
            <div class="random-adjust-group" style="margin-left: auto;">
              <button class="random-btn light" :class="{ active: activeRandomMode === 'light' }"
                      @click="randomizeParams('light')"
                      :disabled="!audioParams.audioEffectsEnabled">轻
              </button>
              <button class="random-btn medium" :class="{ active: activeRandomMode === 'medium' }"
                      @click="randomizeParams('medium')"
                      :disabled="!audioParams.audioEffectsEnabled">中
              </button>
              <button class="random-btn heavy" :class="{ active: activeRandomMode === 'heavy' }"
                      @click="randomizeParams('heavy')"
                      :disabled="!audioParams.audioEffectsEnabled">重
              </button>
            </div>
          </div>
          <div class="card-body" style="min-height: 480px;">
            <AudioControls
              :params="audioParams"
              @update:params="updateParamsFromControls"
            />
          </div>
        </div>
      </div>

      <!-- 中间：仿真预览 -->
      <div class="standard-center-preview">
        <div class="standard-phone-frame">
          <div class="standard-phone-screen">
            <!-- 实时推流预览层 (当驱动开启时显示) -->
            <canvas
                ref="videoCanvas"
                class="video-element"
                :style="{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        opacity: 1,
                        pointerEvents: 'auto',
                        zIndex: 1
                      }"
            ></canvas>



            <!-- 直播间 UI 遮罩 -->
            <div class="live-ui-overlay">
              <div class="live-header">
                <div class="user-info-capsule">
                  <div class="avatar"><img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Douyin" alt="avatar">
                  </div>
                  <div class="meta">
                    <div class="name">MULTIFACED</div>
                    <div class="stats">12.8w 点赞</div>
                  </div>
                  <div class="follow">+ 关注</div>
                </div>
                <div class="viewer-tag">
                  <span class="val">3821</span>
                  <span class="lab">人</span>
                </div>
              </div>

              <!-- 音波实时显示层 -->
              <div class="audio-visual-layer">
              </div>


            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：分析面板 -->
      <div class="standard-side-panel">
        <div class="panel-card tech-card">
          <div class="card-header">
            <span>处理流向图 (DSP Chain)</span>
            <div class="status-indicator" :class="{ 'live': isPlaying }">
              <span class="pulse-dot"></span>
              {{ isPlaying ? '实时处理中' : '就绪' }}
            </div>
          </div>
          <div class="card-body" style="padding: 12px 15px;">
            <div class="dsp-visual-chain-group">
              <div class="dsp-visual-chain" :class="{ 'is-flowing': isPlaying }">
                <!-- Step 1: Source -->
                <div class="dsp-step">
                  <div class="node-hex" :class="{ active: !!audioContext }">
                    <div class="node-inner">Src</div>
                    <div class="node-glow"></div>
                  </div>
                  <div class="flow-connector">
                    <div class="flow-line"></div>
                    <div class="flow-particle"></div>
                  </div>
                </div>

                <!-- Step 2: Dedup -->
                <div class="dsp-step">
                  <div class="node-hex ai" :class="{ active: audioParams.aiDedupEnabled }">
                    <div class="node-inner">AI</div>
                    <div class="node-glow"></div>
                  </div>
                  <div class="flow-connector">
                    <div class="flow-line"></div>
                    <div class="flow-particle"></div>
                  </div>
                </div>

                <!-- Step 3: Comp -->
                <div class="dsp-step">
                  <div class="node-hex" :class="{ active: audioParams.compressorEnabled }">
                    <div class="node-inner">Dyn</div>
                    <div class="node-glow"></div>
                  </div>
                  <div class="flow-connector">
                    <div class="flow-line"></div>
                    <div class="flow-particle"></div>
                  </div>
                </div>

                <!-- Step 4: Output -->
                <div class="dsp-step last">
                  <div class="node-hex" :class="{ active: !!audioContext }">
                    <div class="node-inner">Out</div>
                    <div class="node-glow"></div>
                  </div>
                </div>
              </div>

              <!-- Second Row: Analysis Chain -->
              <div class="dsp-visual-chain secondary" :class="{ 'is-flowing': isPlaying }">
                <div class="dsp-step">
                  <div class="node-hex" :class="{ active: isPlaying }">
                    <div class="node-inner">Spec</div>
                    <div class="node-glow"></div>
                  </div>
                  <div class="flow-connector">
                    <div class="flow-line"></div>
                    <div class="flow-particle"></div>
                  </div>
                </div>
                <div class="dsp-step">
                  <div class="node-hex ai" :class="{ active: isPlaying }">
                    <div class="node-inner">Phas</div>
                    <div class="node-glow"></div>
                  </div>
                  <div class="flow-connector">
                    <div class="flow-line"></div>
                    <div class="flow-particle"></div>
                  </div>
                </div>
                <div class="dsp-step">
                  <div class="node-hex" :class="{ active: isPlaying }">
                    <div class="node-inner">Hash</div>
                    <div class="node-glow"></div>
                  </div>
                  <div class="flow-connector">
                    <div class="flow-line"></div>
                    <div class="flow-particle"></div>
                  </div>
                </div>
                <div class="dsp-step last">
                  <div class="node-hex" :class="{ active: isPlaying }">
                    <div class="node-inner">Sync</div>
                    <div class="node-glow"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-card tech-card">
          <div class="card-header">
            <span>波形对比分析</span>
          </div>
          <div class="card-body" style="min-height: 360px;">
            <div class="comparison-container">
              <div class="waveform-compare-row">
                <div class="waveform-label">视频原声</div>
                <div class="canvas-container">
                  <canvas ref="sourceCanvasRef" class="compare-canvas source"></canvas>
                </div>
              </div>
              <div class="waveform-compare-row" style="margin-top: 20px;">
                <div class="waveform-label processed">去重音频</div>
                <div class="canvas-container">
                  <canvas ref="processedCanvasRef" class="compare-canvas processed"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AudioControls from '@/components/audio/AudioControls.vue'
import {delay} from "@/utils/function";

export default {
  name: 'AudioDedup',
  components: {
    AudioControls
  },

  inject: [
    'syncCanvasToTarget',
    'playGlobalVideo',
    'pauseGlobalVideo',
    'setGlobalVideoCurrentTime',
    'setGlobalVideoMuted',
    'getGlobalVideo',
    'getGlobalAudio',
    'getGlobalGainNode',
    'updateAllVideosAudioSinkId',
    'globalCanvasState',
  ],
  data() {
    return {
      isPageActive: false,
      videoUrl: true,
      videoCanvas: null,
      canvasSyncId: null,

      // 播放状态
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      currentFileName: '',
      currentMedia: null,

      // 波形动画相关
      waveformAnimId: null,
      aiModulationId: null,
      playbackWatchdog: null,

      // 音频处理相关
      audioContext: null,
      sourceNode: null,
      gainNode: null,
      highPassFilter: null,
      delayNode: null,
      echoGain: null,
      delayMix: null,
      jitterOsc: null,
      jitterGain: null,
      bassFilter: null,
      compressor: null,
      panner: null,
      analyser: null,
      sourceAnalyser: null,
      sourceCanvasRef: null,
      processedCanvasRef: null,
      noiseNode: null,
      noiseGain: null,
      lastConnectedElement: null,
      isVirtualCameraLive: false,
      zwplayerOriginalConnection: null,  // 用于记录 zwplayer 的原始连接

      // 同步状态
      isSyncingFromStore: false,
      lastDeactivatedTime: 0,
      lastDeactivatedProgress: 0,

      // 音频参数
      audioParams: {
        volume: 1,
        volumeEnabled: false,
        playbackRate: 1,
        playbackRateEnabled: false,
        pitch: 0,
        pitchEnabled: false,
        bass: 0,
        bassEnabled: false,
        compressorThreshold: -40,
        compressorEnabled: false,
        reverb: 0,
        reverbEnabled: false,
        noiseLevel: 0,
        noiseEnabled: false,
        echoLevel: 0,
        echoEnabled: false,
        vocalClarityLevel: 0,
        vocalClarityEnabled: false,
        pan: 0,
        panEnabled: false,
        aiDedupIntensity: 50,
        aiDedupEnabled: false,
        aiRecomposeIntensity: 50,
        aiRecomposeEnabled: false,
        audioEffectsEnabled: false // 新增：音效开关
      }
    }
  },
  computed: {
    activeRandomMode() {
      return this.$store.state.audioParams.randomMode
    }
  },
  watch: {
    // 监听 store 中的音频参数变化
    '$store.state.audioParams': {
      handler(newGlobalParams) {
        if (this.isPageActive) {
          this.isSyncingFromStore = true
          console.log('[AudioDedup] Global params changed, updating local UI. Mode:', newGlobalParams.randomMode)

          // 使用 $set 逐个设置属性以保持响应性
          this.$set(this.audioParams, 'audioEffectsEnabled', !!newGlobalParams.audioEffectsEnabled) // 新增：同步音效开关
          this.$set(this.audioParams, 'volume', this.ef(newGlobalParams.volume) / 100)
          this.$set(this.audioParams, 'volumeEnabled', !!newGlobalParams.volumeEnabled)
          this.$set(this.audioParams, 'playbackRate', this.ef(newGlobalParams.speed, 1))
          this.$set(this.audioParams, 'playbackRateEnabled', !!newGlobalParams.playbackRateEnabled)
          this.$set(this.audioParams, 'pitch', this.ef(newGlobalParams.pitch))
          this.$set(this.audioParams, 'pitchEnabled', !!newGlobalParams.pitchEnabled)
          this.$set(this.audioParams, 'bass', this.ef(newGlobalParams.bass))
          this.$set(this.audioParams, 'bassEnabled', !!newGlobalParams.bassEnabled)
          this.$set(this.audioParams, 'compressorThreshold', this.ef(newGlobalParams.compressorThreshold, -24))
          this.$set(this.audioParams, 'compressorEnabled', !!newGlobalParams.compressorEnabled)
          this.$set(this.audioParams, 'reverb', 0)
          this.$set(this.audioParams, 'reverbEnabled', false)
          this.$set(this.audioParams, 'noiseLevel', this.ef(newGlobalParams.noiseFloor) / 1000)
          this.$set(this.audioParams, 'noiseEnabled', !!newGlobalParams.noiseEnabled)
          this.$set(this.audioParams, 'echoLevel', this.ef(newGlobalParams.echoLevel, 0))
          this.$set(this.audioParams, 'echoEnabled', !!newGlobalParams.echoEnabled)
          this.$set(this.audioParams, 'vocalClarityLevel', this.ef(newGlobalParams.vocalClarityLevel, 0))
          this.$set(this.audioParams, 'vocalClarityEnabled', !!newGlobalParams.vocalClarityEnabled)
          this.$set(this.audioParams, 'pan', this.ef(newGlobalParams.pan))
          this.$set(this.audioParams, 'panEnabled', !!newGlobalParams.panEnabled)
          this.$set(this.audioParams, 'aiDedupEnabled', !!newGlobalParams.aiDedup || !!newGlobalParams.aiDedupEnabled)
          this.$set(this.audioParams, 'aiDedupIntensity', this.ef(newGlobalParams.aiDedupIntensity, 50))
          this.$set(this.audioParams, 'aiRecomposeEnabled', !!newGlobalParams.aiRecompose || !!newGlobalParams.aiRecomposeEnabled)
          this.$set(this.audioParams, 'aiRecomposeIntensity', this.ef(newGlobalParams.aiRecomposeIntensity, 50))

          console.log("kaisy")
          this.updateAudioNodes();


          setTimeout(() => {
            this.isSyncingFromStore = false
            console.log('[AudioDedup] Sync lock released')
          }, 50)
        }
      },
      deep: true,
      immediate: false
    },
    // 监听本地音频参数变化，同步到 store
    'globalCanvasState.audioSettings.driver'() {
      if (this.isPageActive) {
        this.applySelectedAudioOutput()
      }
    },
    audioParams: {
      handler(newParams) {
        if (this.isSyncingFromStore || !this.isPageActive) {
          if (this.isSyncingFromStore) console.log('[AudioDedup] Local watch blocked (syncing from store)')
          return
        }

        console.log('[AudioDedup] Local params changed manually, committing to store.')
        this.$store.commit('UPDATE_AUDIO_PARAMS', {
          audioEffectsEnabled: !!newParams.audioEffectsEnabled, // 新增：同步音效开关
          volumeEnabled: !!newParams.volumeEnabled,
          volume: this.ef(newParams.volume) * 100,
          playbackRateEnabled: !!newParams.playbackRateEnabled,
          speed: this.ef(newParams.playbackRate, 1),
          pitchEnabled: !!newParams.pitchEnabled,
          pitch: this.ef(newParams.pitch),
          bassEnabled: !!newParams.bassEnabled,
          bass: this.ef(newParams.bass),
          compressorEnabled: !!newParams.compressorEnabled,
          compressorThreshold: this.ef(newParams.compressorThreshold, -24),
          noiseEnabled: !!newParams.noiseEnabled,
          noiseFloor: this.ef(newParams.noiseLevel) * 1000,
          echoLevel: this.ef(newParams.echoLevel, 0),
          echoEnabled: !!newParams.echoEnabled,
          vocalClarityLevel: this.ef(newParams.vocalClarityLevel, 0),
          vocalClarityEnabled: !!newParams.vocalClarityEnabled,
          panEnabled: !!newParams.panEnabled,
          pan: this.ef(newParams.pan),
          aiDedup: !!newParams.aiDedupEnabled,
          aiDedupEnabled: !!newParams.aiDedupEnabled,
          aiDedupIntensity: this.ef(newParams.aiDedupIntensity, 50),
          aiRecompose: !!newParams.aiRecomposeEnabled,
          aiRecomposeEnabled: !!newParams.aiRecomposeEnabled,
          aiRecomposeIntensity: this.ef(newParams.aiRecomposeIntensity, 50)
        })

        this.updateAudioNodes()
      },
      deep: true
    }
  },
  async mounted() {

    this.syncParamsFromStore()
    this.isPlaying = this.$store.state.currentMedia?.isPlaying || false
    this.currentTime = this.$store.state.currentMedia?.currentTime || 0
    this.duration = this.$store.state.currentMedia?.duration || 0

    this.$nextTick(() => {
      this.videoCanvas = this.$refs.videoCanvas
      this.sourceCanvasRef = this.$refs.sourceCanvasRef
      this.processedCanvasRef = this.$refs.processedCanvasRef
    })

    this.isPageActive = true

    // 重新获取 canvas 引用
    this.$nextTick(() => {
      this.videoCanvas = this.$refs.videoCanvas
      this.sourceCanvasRef = this.$refs.sourceCanvasRef
      this.processedCanvasRef = this.$refs.processedCanvasRef
    })

    // 启动 canvas 同步
    this.startCanvasSync()

    await delay(30);

    // 激活时：首先检查视频元素的实际状态
    const globalVideo =  this.getGlobalVideo()


    if (globalVideo) {
      const actualIsPlaying = !globalVideo.paused && !globalVideo.ended
      console.log('[AudioDedup] 媒体实际播放状态:', actualIsPlaying)


      // 读取并同步 globalVideo 的当前音量
      if (!isNaN(globalVideo.volume)) {
        this.audioParams.volume = globalVideo.volume
      }



      if (actualIsPlaying) {

        // 如果媒体正在播放，保持它，不要做任何操作
        console.log('[AudioDedup] 媒体已经在播放，保持当前状态')
        this.isPlaying = true
        this.startPlaybackWatchdog()
      } else if (this.$store.state.currentMedia?.isPlaying) {
        // 如果 store 显示应该播放但媒体没播放，尝试播放

        console.log('[AudioDedup] 尝试恢复播放')
        this.isPlaying = true
        this.$nextTick(async () => {
          if (globalVideo) {
            // 先尝试恢复 AudioContext
            if (this.audioContext && this.audioContext.state === 'suspended') {
              this.audioContext.resume().catch(() => {})
            }
            this.startPlaybackWatchdog()
          }
        })
      }
    }

    if (this.$store.state.currentMedia) {
      const mediaTime = this.$store.state.currentMedia.currentTime || 0
      if (mediaTime > 0.1) {
        this.currentTime = mediaTime
      }
      this.isPlaying = this.$store.state.currentMedia.isPlaying || false
      this.duration = this.$store.state.currentMedia.duration || 0
    }

    this.syncParamsFromStore()

    // 确保初始化音频处理
    if (!this.isVirtualCameraLive) {
      this.initAudioContext().catch(e => console.warn('[AudioDedup] Failed to init audio context:', e))
    }

    setTimeout(() => {
      if (this.isPageActive) {
        this.syncMediaSource()
      }
    }, 100)

  },
  activated() {


    //console.log('[AudioDedup] 页面已激活，保持播放状态')
    //this.isPageActive = true

    // 重新初始化音频处理
    //this.initAudioContext().catch(e => console.warn('[AudioDedup] Failed to init audio context:', e))

    // 重新启动 canvas 同步
    //this.startCanvasSync()

  },
  beforeDestroy() {
    /*this.stopCanvasSync()
    if (this.waveformAnimId) cancelAnimationFrame(this.waveformAnimId)
    if (this.aiModulationId) cancelAnimationFrame(this.aiModulationId)
    this.stopPlaybackWatchdog()*/
  },
  methods: {
    updateParamsFromControls(newParams) {
      const enabledKeys = [
        'volumeEnabled',
        'playbackRateEnabled',
        'pitchEnabled',
        'bassEnabled',
        'compressorEnabled',
        'reverbEnabled',
        'noiseEnabled',
        'echoEnabled',
        'vocalClarityEnabled',
        'panEnabled',
        'aiDedupEnabled',
        'aiRecomposeEnabled'
      ]
      const shouldEnableEffects = enabledKeys.some(key => !!newParams[key])
      Object.keys(newParams).forEach(key => {
        this.$set(this.audioParams, key, newParams[key])
      })
      if (shouldEnableEffects) {
        this.$set(this.audioParams, 'audioEffectsEnabled', true)
        this.$nextTick(() => {
          this.initAudioContext().catch(e => console.warn('[AudioDedup] Failed to init audio context:', e))
        })
      }
    },
    updateParams(key, value) {
      // 音量值需要确保在合法范围内 [0, 2] 用于 UI，但实际设置到视频时会限制到 [0, 1]
      if (key === 'volume') {
        value = Math.max(0, Math.min(2, value))
      }
      this.$set(this.audioParams, key, value)
    },
    // 辅助方法：确保值有效
    ef(value, defaultValue = 0) {
      if (value === null || value === undefined || isNaN(value)) {
        return defaultValue
      }
      return value
    },

    // 从 store 和 globalVideo 同步参数
    syncParamsFromStore() {
      const s = this.$store.state.audioParams
      console.log('[AudioDedup] Syncing params from store:', s)
      this.isSyncingFromStore = true

      // 使用 $set 逐个设置属性以保持响应性
      this.$set(this.audioParams, 'audioEffectsEnabled', !!s.audioEffectsEnabled) // 新增：同步音效开关
      this.$set(this.audioParams, 'volume', s.volume / 100)
      this.$set(this.audioParams, 'volumeEnabled', !!s.volumeEnabled)
      this.$set(this.audioParams, 'playbackRate', s.speed)
      this.$set(this.audioParams, 'playbackRateEnabled', !!s.playbackRateEnabled)
      this.$set(this.audioParams, 'pitch', s.pitch)
      this.$set(this.audioParams, 'pitchEnabled', !!s.pitchEnabled)
      this.$set(this.audioParams, 'bass', s.bass)
      this.$set(this.audioParams, 'bassEnabled', !!s.bassEnabled)
      this.$set(this.audioParams, 'compressorThreshold', s.compressorThreshold)
      this.$set(this.audioParams, 'compressorEnabled', !!s.compressorEnabled)
      this.$set(this.audioParams, 'reverb', 0)
      this.$set(this.audioParams, 'reverbEnabled', false)
      this.$set(this.audioParams, 'noiseLevel', s.noiseFloor / 1000)
      this.$set(this.audioParams, 'noiseEnabled', !!s.noiseEnabled)
      this.$set(this.audioParams, 'echoLevel', this.ef(s.echoLevel, 0))
      this.$set(this.audioParams, 'echoEnabled', !!s.echoEnabled)
      this.$set(this.audioParams, 'vocalClarityLevel', this.ef(s.vocalClarityLevel, 0))
      this.$set(this.audioParams, 'vocalClarityEnabled', !!s.vocalClarityEnabled)
      this.$set(this.audioParams, 'pan', s.pan)
      this.$set(this.audioParams, 'panEnabled', !!s.panEnabled)
      this.$set(this.audioParams, 'aiDedupIntensity', s.aiDedupIntensity)
      this.$set(this.audioParams, 'aiDedupEnabled', !!s.aiDedup || !!s.aiDedupEnabled)
      this.$set(this.audioParams, 'aiRecomposeIntensity', s.aiRecomposeIntensity)
      this.$set(this.audioParams, 'aiRecomposeEnabled', !!s.aiRecompose || !!s.aiRecomposeEnabled)

      this.$nextTick(() => {
        this.isSyncingFromStore = false
      })
    },

    // 停止随机模式
    stopRandomMode() {
      this.$store.commit('UPDATE_AUDIO_PARAMS', { randomMode: null })
    },
    // 随机化参数
    randomizeParams(level) {
      console.log('[AudioDedup] randomizeParams called:', level, 'current active:', this.$store.state.audioParams.randomMode)
      if (this.$store.state.audioParams.randomMode === level) {
        console.log('[AudioDedup] Deselecting mode:', level)
        this.stopRandomMode()
      } else {
        console.log('[AudioDedup] Selecting mode:', level)
        this.$store.commit('UPDATE_AUDIO_PARAMS', { randomMode: level })
      }
    },
    // 新增：切换音效开关
    toggleAudioEffects() {
      // 保存当前的 audioEffectsEnabled 状态
      const enabled = this.audioParams.audioEffectsEnabled
      
      if (enabled) {
        // 开启音效：初始化音频处理链
        this.$store.commit('UPDATE_AUDIO_PARAMS', { audioEffectsEnabled: enabled })
        // 重置所有相关变量，确保重新初始化
        this.audioContext = null
        this.lastConnectedElement = null
        this.gainNode = null
        // 然后重新初始化
        this.initAudioContext()
      } else {
        // 关闭音效：完全断开处理链，source 直接连 destination
        this.$store.commit('UPDATE_AUDIO_PARAMS', {
          audioEffectsEnabled: false,
          volumeEnabled: false,
          volume: 100,
          playbackRateEnabled: false,
          playbackRate: 1,
          speed: 1,
          pitchEnabled: false,
          pitch: 0,
          compressorEnabled: false,
          compressorThreshold: -40,
          bassEnabled: false,
          bass: 0,
          noiseEnabled: false,
          noiseLevel: 0,
          noiseFloor: 0,
          echoEnabled: false,
          echoLevel: 0,
          vocalClarityEnabled: false,
          vocalClarityLevel: 0,
          panEnabled: false,
          pan: 0,
          aiDedupEnabled: false,
          aiDedupIntensity: 50,
          aiDedup: false,
          aiRecomposeEnabled: false,
          aiRecomposeIntensity: 50,
          aiRecompose: false,
          randomMode: null
        })
        
        // 彻底断开处理链，source 直接连接到 destination
        if (this.audioContext && this.sourceNode) {
          try {
            this.sourceNode.disconnect()
          } catch (e) {}
          try {
            this.sourceNode.connect(this.audioContext.destination)
          } catch (e) {}
        }
        
        // 确保视频音量和播放速度恢复到原始值
        const globalVideo = this.getGlobalVideo()
        if (globalVideo) {
          globalVideo.volume = 1.0
          globalVideo.playbackRate = 1.0
        }
        
        // 取消 AI 调制
        if (this.aiModulationId) {
          cancelAnimationFrame(this.aiModulationId)
          this.aiModulationId = null
        }
      }
      
      // 立即更新音频节点
      this.updateAudioNodes()
    },

    // 重置参数
    resetParams() {
      this.$store.commit('UPDATE_AUDIO_PARAMS', {
        volume: 100,
        speed: 1,
        pitch: 0,
        bass: 0,
        noiseFloor: 0,
        echoEnabled: false,
        echoLevel: 0,
        vocalClarityEnabled: false,
        vocalClarityLevel: 0,
        pan: 0,
        compressorThreshold: -24,
        aiDedup: false,
        aiDedupEnabled: false,
        aiDedupIntensity: 50,
        aiRecompose: false,
        aiRecomposeEnabled: false,
        aiRecomposeIntensity: 50,
        randomMode: null
      })
    },

    // 启动 Canvas 同步
    startCanvasSync() {
      if (!this.videoCanvas) {
        this.videoCanvas = this.$refs.videoCanvas
      }
      if (this.canvasSyncId) {
        cancelAnimationFrame(this.canvasSyncId)
      }
      const syncLoop = () => {
        if (!this.isPageActive) return
        if (this.videoCanvas && this.syncCanvasToTarget) {
          try {
            this.syncCanvasToTarget(this.videoCanvas)
          } catch (e) {
            console.warn('[AudioDedup] Canvas sync failed:', e)
          }
        }
        this.canvasSyncId = requestAnimationFrame(syncLoop)
      }
      syncLoop()
    },

    // 停止 Canvas 同步
    stopCanvasSync() {
      if (this.canvasSyncId) {
        cancelAnimationFrame(this.canvasSyncId)
        this.canvasSyncId = null
      }
    },

    applySelectedAudioOutput() {
      const deviceId = this.globalCanvasState?.audioSettings?.driver
      if (!deviceId) return
      if (this.updateAllVideosAudioSinkId) {
        this.updateAllVideosAudioSinkId(deviceId)
        return
      }
      const globalVideo = this.getGlobalVideo()
      if (globalVideo && globalVideo.setSinkId) {
        globalVideo.setSinkId(deviceId).catch(e => {
          console.warn('[AudioDedup] 设置音频输出驱动失败:', e)
        })
      }
      if (this.audioContext && this.audioContext.setSinkId) {
        this.audioContext.setSinkId(deviceId).catch(e => {
          console.warn('[AudioDedup] 设置音频处理链输出失败:', e)
        })
      }
    },

    // 初始化音频上下文和处理节点
    async initAudioContext() {


      const globalVideo =  this.getGlobalVideo()
      const zwplayerAudioContext = this.getGlobalAudio()
      const zwplayerGainNode = this.getGlobalGainNode()
      this.applySelectedAudioOutput()


      if (!globalVideo) {
        console.log('[AudioDedup] No globalVideo available')
        return
      }

      // 简化逻辑：直接使用标准音频处理链
      console.log('[AudioDedup] Initializing audio context')

      if (zwplayerAudioContext && this.audioContext !== zwplayerAudioContext) {
        this.audioContext = zwplayerAudioContext
      }


      // 音效关闭时也需要初始化 analyser，否则右侧两个波形 canvas 没有实时数据
      if (!this.audioParams.audioEffectsEnabled) {
        console.log('[AudioDedup] Audio effects disabled, only drawing waveform')
        if (globalVideo) {
          globalVideo.volume = 1.0
          globalVideo.playbackRate = 1.0
        }
        if (this.audioContext) {
          this.ensureWaveformAnalysers()
        }

        this.startWaveformDrawing()
        return
      }


      if (this.audioContext) {
        if (this.audioContext.state === 'suspended') {
          try {
            await this.audioContext.resume()
            console.log('[AudioDedup] Audio context resumed')
          } catch (e) {
            console.warn('[AudioDedup] Failed to resume audio context:', e)
          }
        }
        if (this.audioParams.audioEffectsEnabled && !this.gainNode) {
          this.initStandardAudioChain(globalVideo, this.audioContext)
        }
        // 如果已经初始化，更新参数和启动波形绘制
        this.updateAudioNodes()
        this.startWaveformDrawing()
        console.log('[AudioDedup] Audio nodes already initialized')
        if (this.audioParams.aiDedupEnabled || this.audioParams.aiRecomposeEnabled) {
          if (!this.aiModulationId) this.updateAIModulation()
        }
        return
      }

      // 创建新的音频上下文或使用 zwplayer 的
      if (zwplayerAudioContext) {
        this.audioContext = zwplayerAudioContext
        console.log("zwplpayer",zwplayerAudioContext)
      } else {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
        console.log('[AudioDedup] Created new audio context')
      }

      const ctx = this.audioContext


      // 使用标准初始化
      console.log('[AudioDedup] Using standard audio chain')
      console.log('---------')

      this.initStandardAudioChain(globalVideo, ctx)

      if (this.gainNode) this.gainNode.gain.value = this.ef(this.audioParams.volume, 1)
      if (this.bassFilter) this.bassFilter.gain.value = this.ef(this.audioParams.bass)
      if (globalVideo) {
        globalVideo.volume = Math.min(this.ef(this.audioParams.volume, 1), 1.0)
        globalVideo.playbackRate = this.ef(this.audioParams.playbackRate, 1)
      }

      this.startWaveformDrawing()
    },

    getMediaSourceNode(globalVideo, ctx) {
      if (!globalVideo || !ctx) return null
      if (!globalVideo._audioSourceNode) {
        globalVideo._audioSourceNode = ctx.createMediaElementSource(globalVideo)
      }
      return globalVideo._audioSourceNode
    },
    ensureWaveformAnalysers() {
      const globalVideo = this.getGlobalVideo()
      if (!this.audioContext || !globalVideo) return

      const source = this.getMediaSourceNode(globalVideo, this.audioContext)
      if (!source) return
      if (!this.sourceAnalyser) {
        this.sourceAnalyser = this.audioContext.createAnalyser()
        this.sourceAnalyser.fftSize = 1024
      }
      if (!this.analyser) {
        this.analyser = this.audioContext.createAnalyser()
        this.analyser.fftSize = 1024
      }
      try {
        source.disconnect()
      } catch (e) {}
      try {
        source.connect(this.sourceAnalyser)
      } catch (e) {}
      try {
        source.connect(this.analyser)
      } catch (e) {}
      try {
        source.connect(this.audioContext.destination)
      } catch (e) {}
    },

    // 初始化标准音频处理链
    initStandardAudioChain(globalVideo, ctx) {


      if (this.lastConnectedElement !== globalVideo) {
        console.log('1')

        if (this.sourceNode) {
          try {
            this.sourceNode.disconnect()
          } catch (e) {}
        }

        try {
          this.sourceNode = this.getMediaSourceNode(globalVideo, ctx)
          this.lastConnectedElement = globalVideo
        } catch (e) {
          console.warn('[AudioDedup] createMediaElementSource failed:', e)
        }
      }

      if (!this.gainNode) {
        if (this.analyser) {
          try {
            this.analyser.disconnect()
          } catch (e) {}
        }
        if (this.sourceAnalyser) {
          try {
            this.sourceAnalyser.disconnect()
          } catch (e) {}
        }
        this.createAudioProcessingChain(ctx)
        this.connectSourceToChain()
        
        // 连接到 destination
        this.analyser.connect(ctx.destination)
      }
    },

    // 创建音频处理链节点
    createAudioProcessingChain(ctx) {
      const gain = ctx.createGain()
      const highPassFilter = ctx.createBiquadFilter()
      highPassFilter.type = 'highpass'
      highPassFilter.frequency.value = 80



      // 多段 EQ 滤波器 - 用于改变音频指纹
      const eqLow = ctx.createBiquadFilter()
      eqLow.type = 'peaking'
      eqLow.frequency.value = 150
      eqLow.Q.value = 1
      eqLow.gain.value = 0
      
      const eqMid = ctx.createBiquadFilter()
      eqMid.type = 'peaking'
      eqMid.frequency.value = 1000
      eqMid.Q.value = 1
      eqMid.gain.value = 0
      
      const eqHigh = ctx.createBiquadFilter()
      eqHigh.type = 'peaking'
      eqHigh.frequency.value = 4000
      eqHigh.Q.value = 1
      eqHigh.gain.value = 0

      const filter = ctx.createBiquadFilter() // 低音增强
      const comp = ctx.createDynamicsCompressor()
      const anal = ctx.createAnalyser()
      const srcAnal = ctx.createAnalyser()


      anal.fftSize = 1024
      srcAnal.fftSize = 1024

      // 回声效果（使用延迟线）- 更明显的延迟，带反馈循环
      const delayNode = ctx.createDelay(1.0) // 最大延迟 1.0s
      // 设置一个合理的延迟时间（0.3秒）
      delayNode.delayTime.value = 0.3
      const echoGain = ctx.createGain()
      echoGain.gain.value = 0
      const feedbackGain = ctx.createGain()
      feedbackGain.gain.value = 0.3 // 反馈增益，控制回声衰减速度
      const delayMix = ctx.createGain()
      delayMix.gain.value = 1
      
      // 反馈循环：延迟输出 -> 反馈增益 -> 延迟输入
      delayNode.connect(feedbackGain)
      feedbackGain.connect(delayNode)

      // 高频抖动效果 - 增强抖动强度
      const jitterOsc = ctx.createOscillator()
      const jitterGain = ctx.createGain()
      jitterGain.gain.value = 0
      jitterOsc.frequency.value = 15 // 提高频率
      jitterOsc.type = 'triangle' // 更有特色的波形
      
      // Jitter 连接到高频滤波器的频率参数
      const jitterModGain = ctx.createGain()
      jitterModGain.gain.value = 0
      jitterOsc.connect(jitterModGain)
      jitterModGain.connect(highPassFilter.frequency)



      // AI 去重滤波器 - 增强效果
      const aiDedup = ctx.createBiquadFilter()
      aiDedup.type = 'peaking'
      aiDedup.frequency.value = 1000
      aiDedup.Q.value = 2
      aiDedup.gain.value = 0

      const aiRecompComp = ctx.createDynamicsCompressor()
      aiRecompComp.threshold.value = -10
      aiRecompComp.ratio.value = 1

      const aiRecompGain = ctx.createGain()
      aiRecompGain.gain.value = 1.0

      filter.type = 'lowshelf'
      filter.frequency.value = 200

      comp.threshold.setValueAtTime(this.ef(this.audioParams.compressorThreshold, -24), ctx.currentTime)
      comp.knee.setValueAtTime(40, ctx.currentTime)
      comp.ratio.setValueAtTime(12, ctx.currentTime)
      comp.attack.setValueAtTime(0, ctx.currentTime)
      comp.release.setValueAtTime(0.25, ctx.currentTime)

      // 底噪 - 增强强度
      const bufferSize = 2 * ctx.sampleRate
      const noiseBuffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate)
      const output = noiseBuffer.getChannelData(0)
      for (let i = 0; i < bufferSize; i++) {
        output[i] = Math.random() * 2 - 1
      }
      const noiseSrc = ctx.createBufferSource()
      noiseSrc.buffer = noiseBuffer
      noiseSrc.loop = true
      const nGain = ctx.createGain()
      nGain.gain.value = this.ef(this.audioParams.noiseLevel)
      const noiseMixer = ctx.createGain()
      noiseMixer.gain.value = 1
      
      // 相位调制器 - 用于改变音频指纹
      const phaserDelay = ctx.createDelay(0.01)
      const phaserOsc = ctx.createOscillator()
      const phaserGain = ctx.createGain()
      phaserOsc.frequency.value = 0.5
      phaserOsc.type = 'sine'
      phaserGain.gain.value = 0
      phaserOsc.connect(phaserGain)
      phaserGain.connect(phaserDelay.delayTime)

      jitterOsc.start()
      phaserOsc.start()
      noiseSrc.start()

      this.gainNode = gain
      this.highPassFilter = highPassFilter
      this.eqLow = eqLow
      this.eqMid = eqMid
      this.eqHigh = eqHigh
      this.delayNode = delayNode
      this.echoGain = echoGain
      this.feedbackGain = feedbackGain
      this.delayMix = delayMix
      this.jitterOsc = jitterOsc
      this.jitterGain = jitterGain
      this.jitterModGain = jitterModGain
      this.phaserDelay = phaserDelay
      this.phaserOsc = phaserOsc
      this.phaserGain = phaserGain
      this.bassFilter = filter
      this.compressor = comp
      this.analyser = anal
      this.sourceAnalyser = srcAnal
      this.noiseNode = noiseSrc
      this.noiseGain = nGain
      this.noiseMixer = noiseMixer
      this.aiDedupFilter = aiDedup
      this.aiRecomposeComp = aiRecompComp
      this.aiRecomposeGain = aiRecompGain
    },

    // 连接源到处理链
    connectSourceToChain() {
      if (!this.sourceNode || !this.highPassFilter) return

      const ctx = this.audioContext
      try {
        this.sourceNode.disconnect()
      } catch (e) {}
      
      // 主信号链路 - 更复杂的处理链
      this.highPassFilter.connect(this.eqLow)
      this.eqLow.connect(this.eqMid)
      this.eqMid.connect(this.eqHigh)
      this.eqHigh.connect(this.bassFilter)
      this.bassFilter.connect(this.compressor)
      this.compressor.connect(this.aiDedupFilter)
      this.aiDedupFilter.connect(this.aiRecomposeComp)
      this.aiRecomposeComp.connect(this.aiRecomposeGain)
      this.aiRecomposeGain.connect(this.gainNode)
      
      // 底噪混合到主信号
      this.noiseNode.connect(this.noiseGain)
      this.noiseGain.connect(this.gainNode)
      
      // 回声效果连接
      this.aiRecomposeGain.connect(this.delayNode)
      this.delayNode.connect(this.echoGain)
      this.echoGain.connect(this.gainNode)
      
      this.gainNode.connect(this.analyser)

      // 连接源节点
      this.sourceNode.connect(this.sourceAnalyser)
      this.sourceNode.connect(this.highPassFilter)
    },

    // 新增：重置音频处理链，让它完全透明（不影响原始声音）
    resetAudioChain() {
      console.log('[AudioDedup] Resetting audio chain to be completely transparent')
      
      const globalVideo = this.getGlobalVideo()
      
      if (!this.audioContext) return
      const ctx = this.audioContext
      const t = ctx.currentTime
      
      // 所有音频节点增益设为 1.0 或 0，让处理链完全透明
      if (this.gainNode) {
        this.gainNode.gain.setTargetAtTime(1.0, t, 0.1)
      }
      if (this.highPassFilter) {
        this.highPassFilter.frequency.setTargetAtTime(0, t, 0.1) // 让所有频率通过
        this.highPassFilter.Q.setTargetAtTime(1, t, 0.1)
        this.highPassFilter.gain.setTargetAtTime(0, t, 0.1)
      }
      if (this.eqLow) {
        this.eqLow.gain.setTargetAtTime(0, t, 0.1)
      }
      if (this.eqMid) {
        this.eqMid.gain.setTargetAtTime(0, t, 0.1)
      }
      if (this.eqHigh) {
        this.eqHigh.gain.setTargetAtTime(0, t, 0.1)
      }
      if (this.bassFilter) {
        this.bassFilter.gain.setTargetAtTime(0, t, 0.1)
      }
      if (this.compressor) {
        this.compressor.ratio.setTargetAtTime(1, t, 0.1) // 1:1 压缩等于不压缩
        this.compressor.threshold.setTargetAtTime(-24, t, 0.1)
      }
      if (this.noiseGain) {
        this.noiseGain.gain.setTargetAtTime(0, t, 0.1) // 关闭底噪
      }
      if (this.echoGain) {
        this.echoGain.gain.setTargetAtTime(0, t, 0.1) // 关闭回声
      }
      if (this.phaserGain) {
        this.phaserGain.gain.setTargetAtTime(0, t, 0.1) // 关闭相位调制
      }
      if (this.jitterGain) {
        this.jitterGain.gain.setTargetAtTime(0, t, 0.1) // 关闭抖动
      }
      if (this.jitterModGain) {
        this.jitterModGain.gain.setTargetAtTime(0, t, 0.1)
      }
      if (this.aiDedupFilter) {
        this.aiDedupFilter.gain.setTargetAtTime(0, t, 0.1) // 关闭 AI 去重
        this.aiDedupFilter.detune.setTargetAtTime(0, t, 0.1)
        this.aiDedupFilter.frequency.setTargetAtTime(1000, t, 0.1)
      }
      if (this.aiRecomposeComp) {
        this.aiRecomposeComp.ratio.setTargetAtTime(1, t, 0.1)
        this.aiRecomposeComp.threshold.setTargetAtTime(-24, t, 0.1)
      }
      if (this.aiRecomposeGain) {
        this.aiRecomposeGain.gain.setTargetAtTime(1.0, t, 0.1)
      }

      console.log(globalVideo,"--------------")
      // 确保视频恢复到原始音量和播放速度
      if (globalVideo) {
        globalVideo.volume = 1.0
        globalVideo.playbackRate = 1.0
      }
      
      // 取消 AI 调制动画
      if (this.aiModulationId) {
        cancelAnimationFrame(this.aiModulationId)
        this.aiModulationId = null
      }
    },

    // 更新音频节点
    async updateAudioNodes() {
      console.log('[AudioDedup] updateAudioNodes called', this.audioParams)
      console.log("this.audioContext", this.audioContext)

      if (!this.audioContext) return
      const ctx = this.audioContext


      const t = ctx.currentTime
      const p = this.audioParams
      
      // 新增：如果全局音效开关关闭，禁用所有音效
      if (!p.audioEffectsEnabled) {
        // 禁用所有音频效果
        if (this.gainNode) {
          this.gainNode.gain.setTargetAtTime(1.0, t, 0.1)
        }
        if (this.aiDedupFilter) {
          this.aiDedupFilter.detune.setTargetAtTime(0, t, 0.1)
          this.aiDedupFilter.frequency.setTargetAtTime(1000, t, 0.1)
          this.aiDedupFilter.gain.setTargetAtTime(0, t, 0.1)
        }
        if (this.eqLow) {
          this.eqLow.gain.setTargetAtTime(0, t, 0.1)
        }
        if (this.eqMid) {
          this.eqMid.gain.setTargetAtTime(0, t, 0.1)
      }
      if (this.eqHigh) {
        this.eqHigh.gain.setTargetAtTime(0, t, 0.1)
      }
      if (this.bassFilter) {
          this.bassFilter.gain.setTargetAtTime(0, t, 0.1)
        }
        if (this.compressor) {
          this.compressor.ratio.setTargetAtTime(1, t, 0.1)
        }
        if (this.noiseGain) {
          this.noiseGain.gain.setTargetAtTime(0, t, 0.1)
        }
        if (this.echoGain) {
          this.echoGain.gain.setTargetAtTime(0, t, 0.1)
        }
        if (this.jitterGain) {
          this.jitterGain.gain.setTargetAtTime(0, t, 0.1)
        }
        if (this.jitterModGain) {
          this.jitterModGain.gain.setTargetAtTime(0, t, 0.1)
        }
        if (this.aiRecomposeComp) {
          this.aiRecomposeComp.threshold.setValueAtTime(-24, t)
          this.aiRecomposeComp.ratio.setValueAtTime(1, t)
        }
        if (this.aiRecomposeGain) {
          this.aiRecomposeGain.gain.setValueAtTime(1.0, t)
        }
        
        // 恢复视频音量和播放速度
        const globalVideo = this.getGlobalVideo()
        if (globalVideo) {
          globalVideo.volume = 1.0
          globalVideo.playbackRate = 1.0
        }
        
        return
      }


      if (this.gainNode) {
        const targetVal = p.volumeEnabled ? this.ef(p.volume, 1) : 1.0

        this.gainNode.gain.setTargetAtTime(targetVal, t, 0.1)
        console.log('[AudioDedup] Updating gainNode value:', targetVal)
      }

      const globalVideo = this.getGlobalVideo()

      // 同时更新视频元素的音量，确保即使音频处理链没生效也能控制音量
      if (globalVideo) {
        const targetVolume = p.volumeEnabled ? Math.min(this.ef(p.volume, 1), 1.0) : 1.0
        if (globalVideo.volume !== targetVolume) {
          globalVideo.volume = targetVolume
          console.log('[AudioDedup] Updating video volume:', targetVolume)
        }
      }

      if (globalVideo) {
        // 更新播放速度
        const targetRate = p.playbackRateEnabled ? this.ef(p.playbackRate, 1) : 1.0
        if (globalVideo.playbackRate !== targetRate) {
          globalVideo.playbackRate = targetRate
        }
      }

      // 音调偏移 (Pitch) - 只有开启时才应用，关闭时恢复为0
      if (this.aiDedupFilter) {
        const targetPitch = p.pitchEnabled ? this.ef(p.pitch) : 0
        this.aiDedupFilter.detune.setTargetAtTime(targetPitch, t, 0.1)
      }

      // 多段 EQ - 用于改变音频指纹（仅在AI去重开启且人声清晰度增强关闭时使用）
      if (this.eqLow && this.eqMid && this.eqHigh) {
        if ((p.aiDedupEnabled || p.aiRecomposeEnabled) && !p.vocalClarityEnabled) {
          // 动态 EQ 变化会在 updateAIModulation 中处理
        } else if (!p.vocalClarityEnabled) {
          this.eqLow.gain.setTargetAtTime(0, t, 0.1)
          this.eqMid.gain.setTargetAtTime(0, t, 0.1)
          this.eqHigh.gain.setTargetAtTime(0, t, 0.1)
        }
        // 如果人声清晰度增强开启，它会在后面的代码中设置正确的 EQ 值
      }

      if (this.bassFilter) {
        const targetVal = p.bassEnabled ? this.ef(p.bass) : 0
        this.bassFilter.gain.setTargetAtTime(targetVal, t, 0.1)
      }

      if (this.compressor) {
        const enabled = p.compressorEnabled
        let ratio = enabled ? 12 : 1
        ratio = Math.max(1, Math.min(20, ratio))
        this.compressor.ratio.setTargetAtTime(ratio, t, 0.1)
        if (enabled) {
          this.compressor.threshold.setTargetAtTime(this.ef(p.compressorThreshold, -24), t, 0.1)
        } else {
          // 开关关闭时，threshold也要恢复到默认值
          this.compressor.threshold.setTargetAtTime(-24, t, 0.1)
        }
      }

      if (this.noiseGain) {
        const targetVal = p.noiseEnabled ? this.ef(p.noiseLevel) : 0
        this.noiseGain.gain.setTargetAtTime(targetVal, t, 0.1)
      }

      if (this.echoGain) {
        const targetVal = p.echoEnabled ? this.ef(p.echoLevel) : 0
        this.echoGain.gain.setTargetAtTime(targetVal, t, 0.1)
      }
      
      // 人声清晰度增强
      console.log('[AudioDedup] Vocal Clarity: enabled=', p.vocalClarityEnabled, 'level=', p.vocalClarityLevel)
      if (this.eqLow && this.eqMid && this.eqHigh) {
        if (p.vocalClarityEnabled) {
          // 人声清晰度增强：降低低频（减少杂音），提升中高频（提升人声清晰度）
          const clarityLevel = this.ef(p.vocalClarityLevel, 0)
          console.log('[AudioDedup] Applying vocal clarity:', clarityLevel)
          // 降低低频（150Hz），减少背景杂音
          this.eqLow.gain.setTargetAtTime(-clarityLevel * 2.0, t, 0.1)
          // 提升中频（1000Hz），人声主要频段
          this.eqMid.gain.setTargetAtTime(clarityLevel * 3.0, t, 0.1)
          // 提升高频（4000Hz），增强人声的亮度和清晰度
          this.eqHigh.gain.setTargetAtTime(clarityLevel * 4.0, t, 0.1)
        } else {
          // 关闭时恢复正常
          this.eqLow.gain.setTargetAtTime(0, t, 0.1)
          this.eqMid.gain.setTargetAtTime(0, t, 0.1)
          this.eqHigh.gain.setTargetAtTime(0, t, 0.1)
        }
      }
    },

    // 开始绘制波形
    startWaveformDrawing() {

      console.log("开始绘制")
      console.log(this.waveformAnimId)


      if (this.waveformAnimId) {
        cancelAnimationFrame(this.waveformAnimId)
      }

      const drawWaveforms = () => {
        if (!this.isPageActive) return

        this.drawSourceWaveform()
        this.drawProcessedWaveform()

        this.waveformAnimId = requestAnimationFrame(drawWaveforms)
      }

      drawWaveforms()
    },

    // 绘制源波形
    drawSourceWaveform() {
      if (!this.sourceCanvasRef || !this.sourceAnalyser) return


      const canvas = this.sourceCanvasRef
      const ctx = canvas.getContext('2d')
      const bufferLength = this.sourceAnalyser.frequencyBinCount




      const dataArray = new Uint8Array(bufferLength)


      this.sourceAnalyser.getByteTimeDomainData(dataArray)

      // 获取画布实际显示尺寸
      const width = canvas.offsetWidth || 328
      const height = canvas.offsetHeight || 75

      // 设置画布为高分辨率（2倍）
      const dpr = 2
      canvas.width = width * dpr
      canvas.height = height * dpr

      // 缩放坐标系以匹配显示尺寸
      ctx.scale(dpr, dpr)

      // 绘制背景
      ctx.fillStyle = 'rgba(0, 0, 0, 0.3)'
      ctx.fillRect(0, 0, width, height)

      // 绘制波形
      ctx.lineWidth = 2
      ctx.strokeStyle = '#666'
      ctx.beginPath()

      const sliceWidth = width / bufferLength
      let x = 0

      for (let i = 0; i < bufferLength; i++) {
        const v = dataArray[i] / 128.0
        const y = (v * height) / 2

        if (i === 0) {
          ctx.moveTo(x, y)
        } else {
          ctx.lineTo(x, y)
        }

        x += sliceWidth
      }

      ctx.lineTo(width, height / 2)
      ctx.stroke()
    },

    // 绘制处理后的波形
    drawProcessedWaveform() {
      if (!this.processedCanvasRef || !this.analyser) return

      const canvas = this.processedCanvasRef
      const ctx = canvas.getContext('2d')
      const bufferLength = this.analyser.frequencyBinCount
      const dataArray = new Uint8Array(bufferLength)

      this.analyser.getByteTimeDomainData(dataArray)


      // 获取画布实际显示尺寸
      const width = canvas.offsetWidth || 328
      const height = canvas.offsetHeight || 75

      // 设置画布为高分辨率（2倍）
      const dpr = 2
      canvas.width = width * dpr
      canvas.height = height * dpr

      // 缩放坐标系以匹配显示尺寸
      ctx.scale(dpr, dpr)

      // 绘制背景
      ctx.fillStyle = 'rgba(0, 0, 0, 0.3)'
      ctx.fillRect(0, 0, width, height)

      // 绘制波形
      ctx.lineWidth = 2
      ctx.strokeStyle = '#00d4ff'
      ctx.shadowBlur = 10
      ctx.shadowColor = '#00d4ff'
      ctx.beginPath()

      const sliceWidth = width / bufferLength
      let x = 0

      for (let i = 0; i < bufferLength; i++) {
        const v = dataArray[i] / 128.0
        const y = (v * height) / 2

        if (i === 0) {
          ctx.moveTo(x, y)
        } else {
          ctx.lineTo(x, y)
        }

        x += sliceWidth
      }

      ctx.lineTo(width, height / 2)
      ctx.stroke()
    },

    // 更新 AI 调制
    updateAIModulation() {
      // 新增：如果全局音效开关关闭，不执行 AI 调制
      if (!this.audioParams.audioEffectsEnabled) {
        if (this.aiModulationId) {
          cancelAnimationFrame(this.aiModulationId)
          this.aiModulationId = null
        }
        return
      }

      if (  !this.audioParams.aiDedupEnabled && !this.audioParams.aiRecomposeEnabled) {
        if (this.aiModulationId) {
          cancelAnimationFrame(this.aiModulationId)
          this.aiModulationId = null
        }
        return
      }


      const modulate = () => {
        if (!this.isPageActive) return

        if (this.aiDedupFilter) {
          const intensity = this.audioParams.aiDedupEnabled ? this.ef(this.audioParams.aiDedupIntensity, 50) / 100 : 0
          const t = this.audioContext.currentTime

          // 1. 基础频率调制
          const baseFreq = 1000
          const dynamicFreq = Math.sin(t * 2) * 800 * intensity
          this.aiDedupFilter.frequency.setTargetAtTime(this.ef(baseFreq + dynamicFreq), t, 0.1)

          // 2. 音调偏移 (Pitch) 直接作用于 detune 属性 - 只有开启时才应用
          const targetPitch = this.audioParams.pitchEnabled ? this.ef(this.audioParams.pitch) : 0
          this.aiDedupFilter.detune.setTargetAtTime(targetPitch, t, 0.1)

          // 3. 增益调制
          const dynamicGain = Math.sin(t * 5) * 6 * intensity
          this.aiDedupFilter.gain.setTargetAtTime(this.ef(dynamicGain), t, 0.1)
        }

        if (this.aiRecomposeComp && this.aiRecomposeGain && this.audioParams.aiRecomposeEnabled) {
          const intensity = this.ef(this.audioParams.aiRecomposeIntensity, 50) / 100
          const time = Date.now() / 1000
          
          const threshold = -18 + Math.sin(time * 1.2) * 12
          let ratio = 3 + Math.sin(time * 1.8) * 3
          ratio = Math.max(1, Math.min(20, ratio)) // 确保ratio在有效范围内
          
          this.aiRecomposeComp.threshold.setValueAtTime(threshold, this.audioContext.currentTime)
          this.aiRecomposeComp.ratio.setValueAtTime(ratio, this.audioContext.currentTime)
          this.aiRecomposeGain.gain.setValueAtTime(1 + intensity * 0.4, this.audioContext.currentTime)
        }
        
        // 多段 EQ 动态变化 - 更自然的强度（仅在人声清晰度增强关闭时使用）
        if (this.eqLow && this.eqMid && this.eqHigh && (this.audioParams.aiDedupEnabled || this.audioParams.aiRecomposeEnabled) && !this.audioParams.vocalClarityEnabled) {
          const time = Date.now() / 1000
          const intensity = Math.max(
            this.ef(this.audioParams.aiDedupIntensity, 50),
            this.ef(this.audioParams.aiRecomposeIntensity, 50)
          ) / 100
          
          const lowGain = Math.sin(time * 1.1) * 3.5 * intensity
          const midGain = Math.cos(time * 1.4) * 3 * intensity
          const highGain = Math.sin(time * 1.7) * 4 * intensity
          
          this.eqLow.gain.setValueAtTime(lowGain, this.audioContext.currentTime)
          this.eqMid.gain.setValueAtTime(midGain, this.audioContext.currentTime)
          this.eqHigh.gain.setValueAtTime(highGain, this.audioContext.currentTime)
          
          // 动态改变 EQ 频率
          this.eqLow.frequency.setValueAtTime(120 + Math.sin(time * 0.7) * 50, this.audioContext.currentTime)
          this.eqMid.frequency.setValueAtTime(900 + Math.cos(time * 0.9) * 400, this.audioContext.currentTime)
          this.eqHigh.frequency.setValueAtTime(3200 + Math.sin(time * 0.8) * 1000, this.audioContext.currentTime)
        }
        
        this.aiModulationId = requestAnimationFrame(modulate)
      }
      
      modulate()
    },
    
    // 同步媒体源
    async syncMediaSource() {
      // 只获取状态，不设置本地源
      await delay(30);

      const globalVideo = this.getGlobalVideo()
      if (globalVideo) {
        this.duration = globalVideo.duration || 0
        this.currentTime = globalVideo.currentTime || 0
        this.isPlaying = !globalVideo.paused && !globalVideo.ended
      }
    },
    
    // 同步到 store
   async syncToStore() {
      const globalVideo = this.getGlobalVideo()
      if (globalVideo) {
        const currentTime = globalVideo.currentTime
        const isPlaying = !globalVideo.paused && !globalVideo.ended
        const duration = globalVideo.duration
        this.$store.commit('UPDATE_MEDIA_STATE', {
          isPlaying,
          currentTime,
          duration
        })
        
        this.isPlaying = isPlaying
        this.currentTime = currentTime
        this.duration = duration
      }
    },
    
    // 开始播放监控
    startPlaybackWatchdog() {
      this.stopPlaybackWatchdog()
      this.playbackWatchdog = setInterval(() => {
        this.syncToStore()
      }, 100)
    },
    
    // 停止播放监控
    stopPlaybackWatchdog() {
      if (this.playbackWatchdog) {
        clearInterval(this.playbackWatchdog)
        this.playbackWatchdog = null
      }
    }
  }
}
</script>

<style scoped>
.standard-feature-page {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.standard-feature-layout {
  display: flex;
  flex: 1;
  gap: 16px;
  height: 100%;
  padding-right: 0;
}

.standard-side-panel {
  width: 360px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.standard-center-preview {
  flex: 1;
  display: flex;
  justify-content: center;
}

.standard-phone-screen {
  width: 100%;
  height: 100%;
  position: relative;
}

.video-element {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.panel-card {
  background: rgba(20, 20, 20, 0.6);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 212, 255, 0.08);
}

.tech-card {
  position: relative;
}

.tech-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.4), transparent);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  border-bottom: 1px solid #2a2a2a;
  color: #b0b0b0;
  font-size: 12px;
  font-weight: 600;
}

.card-header span {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  flex: 1;
}

.icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 212, 255, 0.12);
  border-radius: 8px;
  color: #00d4ff;
}

.card-body {
  padding: 10px;
  min-height: 130px;
  display: flex;
  flex-direction: column;
}

.random-adjust-group {
  display: flex;
  gap: 4px;
}

.random-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #333;
  color: #888;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.random-btn.active {
  background: rgba(0, 212, 255, 0.1);
  border-color: #00d4ff;
  color: #00d4ff;
}

.cyber-switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 18px;
}

.cyber-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  transition: 0.4s;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.switch-slider::before {
  position: absolute;
  content: '';
  height: 12px;
  width: 12px;
  left: 2px;
  bottom: 2px;
  background-color: #666;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .switch-slider {
  background-color: rgba(0, 212, 255, 0.2);
  border-color: var(--accent);
}

input:checked + .switch-slider::before {
  transform: translateX(14px);
  background-color: var(--accent);
  box-shadow: 0 0 8px var(--accent);
}

.audio-mock-bg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #1a1a1a 0%, #000 100%);
}

.audio-icon-pulse {
  animation: audioPulse 2s infinite ease-in-out;
  margin-bottom: 20px;
}

@keyframes audioPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
}

.audio-filename {
  color: #888;
  font-size: 12px;
  max-width: 80%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.audio-visual-layer {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.live-ui-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
}

.live-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-info-capsule {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.5);
  padding: 6px 10px;
  border-radius: 20px;
}

.user-info-capsule .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
}

.user-info-capsule .avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info-capsule .meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-info-capsule .name {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.user-info-capsule .stats {
  color: rgba(255, 255, 255, 0.8);
  font-size: 11px;
}

.user-info-capsule .follow {
  background: #fe2c55;
  color: #fff;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.viewer-tag {
  background: rgba(0, 0, 0, 0.5);
  padding: 4px 10px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.viewer-tag .val {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.viewer-tag .lab {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
}

.live-bottom-area {
  margin-top: auto;
  padding: 16px;
  position: relative;
}

.comment-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 150px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  z-index: -1;
}

.dsp-visual-chain-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.dsp-visual-chain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  position: relative;
}

.dsp-step {
  display: flex;
  align-items: center;
  flex: 1;
  position: relative;
}

.dsp-step.last {
  flex: 0;
}

.node-hex {
  width: 46px;
  height: 40px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(40, 40, 40, 0.4);
  border: 1px solid #333;
  border-radius: 6px;
  color: #666;
  font-size: 10px;
  font-weight: 800;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 2;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.node-hex.active {
  border-color: #00d4ff;
  color: #fff;
  background: rgba(0, 212, 255, 0.15);
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2), inset 0 0 10px rgba(0, 212, 255, 0.1);
}

.node-hex.ai.active {
  border-color: #7c3aed;
  background: rgba(124, 58, 237, 0.15);
  box-shadow: 0 0 20px rgba(124, 58, 237, 0.2), inset 0 0 10px rgba(124, 58, 237, 0.1);
}

.node-inner {
  position: relative;
  z-index: 3;
}

.node-glow {
  position: absolute;
  inset: -2px;
  border-radius: 8px;
  opacity: 0;
  background: radial-gradient(circle, rgba(0, 212, 255, 0.4) 0%, transparent 70%);
  transition: opacity 0.4s;
}

.node-hex.active .node-glow {
  opacity: 1;
  animation: nodePulse 2s infinite ease-in-out;
}

@keyframes nodePulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}

.flow-connector {
  flex: 1;
  height: 2px;
  position: relative;
  margin: 0 -1px;
}

.flow-line {
  width: 100%;
  height: 100%;
  background: #222;
  transition: background 0.4s;
}

.is-flowing .flow-line {
  background: linear-gradient(90deg, #222, #444, #222);
}

.flow-particle {
  position: absolute;
  top: 50%;
  left: 0;
  width: 6px;
  height: 6px;
  background: #00d4ff;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 10px #00d4ff, 0 0 20px rgba(0, 212, 255, 0.5);
  opacity: 0;
  pointer-events: none;
}

.is-flowing .flow-particle {
  opacity: 1;
  animation: particleFlow 1.5s infinite linear;
}

.dsp-step:nth-child(2) .flow-particle {
  animation-delay: 0.5s;
}

.dsp-step:nth-child(3) .flow-particle {
  animation-delay: 1.0s;
}

@keyframes particleFlow {
  0% {
    left: 0;
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    left: 100%;
    opacity: 0;
  }
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  color: #666;
  background: rgba(255, 255, 255, 0.03);
  padding: 2px 8px;
  border-radius: 10px;
  border: 1px solid #222;
}

.status-indicator.live {
  color: #00d4ff;
  border-color: rgba(0, 212, 255, 0.2);
}

.pulse-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #444;
}

.live .pulse-dot {
  background: #00d4ff;
  animation: livePulse 1.5s infinite;
}

@keyframes livePulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 212, 255, 0.7);
  }
  70% {
    transform: scale(1.2);
    box-shadow: 0 0 0 6px rgba(0, 212, 255, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 212, 255, 0);
  }
}

.comparison-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  flex: 1;
}

.waveform-compare-row {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.waveform-label {
  font-size: 11px;
  color: #888;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.waveform-label::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #555;
}

.waveform-label.processed::before {
  background: #00d4ff;
  box-shadow: 0 0 5px #00d4ff;
}

.canvas-container {
  flex: 1;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  border: 1px solid #222;
  overflow: hidden;
  position: relative;
  min-height: 80px;
}

.compare-canvas {
  width: 100%;
  height: 100%;
  display: block;
}

.audio-controls {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.control-section {
  padding-bottom: 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.control-section:last-child {
  border-bottom: none;
}

.section-title {
  font-size: 11px;
  font-weight: 700;
  color: var(--accent);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 10px;
  opacity: 0.8;
}

.control-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.control-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
  transition: opacity 0.3s ease;
}

.control-group.disabled .slider-wrap {
  opacity: 0.4;
  pointer-events: none;
}

/* AI Special Section Styles - Crystal Cyan Style */
.ai-special-section {
  position: relative;
  border-bottom: none;
  background: linear-gradient(to right, rgba(0, 212, 255, 0.08), rgba(0, 212, 255, 0.02));
  margin: 0 -20px;
  padding: 14px 20px;
  /* 移除左侧圆角以防止边框溢出，右侧保持圆角 */
  border-radius: 0 8px 8px 0;
  box-shadow: inset 10px 0 20px -10px rgba(0, 212, 255, 0.1);
  overflow: hidden;
}

.ai-special-section::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--accent);
  box-shadow: 0 0 10px var(--accent-glow);
}

.ai-special-section .section-title {
  color: #fff;
  text-shadow: 0 0 10px var(--accent-glow);
  letter-spacing: 1px;
  font-size: 16px;
  font-family: 'JetBrains Mono', 'PingFang SC', sans-serif;
  font-weight: 700;
  font-style: italic;
  opacity: 1;
}

.control-value.ai {
  color: var(--accent);
  font-weight: bold;
}

.cyber-slider.ai::-webkit-slider-thumb {
  background: #fff;
  border: 2px solid var(--accent);
  box-shadow: 0 0 10px var(--accent);
}

.cyber-switch.ai input:checked + .switch-slider {
  background-color: rgba(0, 212, 255, 0.2);
  border-color: var(--accent);
}

.cyber-switch.ai input:checked + .switch-slider:before {
  background-color: #fff;
  box-shadow: 0 0 12px var(--accent);
}

.label-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0; /* 允许子元素在 flex 容器中缩小 */
}

.control-label {
  font-size: 11px; /* 稍微调小字号防止溢出 */
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Cyber Switch Style */
.cyber-switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 18px;
}

.cyber-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.1);
  transition: .4s;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.switch-slider:before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  left: 2px;
  bottom: 2px;
  background-color: #666;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .switch-slider {
  background-color: rgba(0, 212, 255, 0.2);
  border-color: var(--accent);
}

input:checked + .switch-slider:before {
  transform: translateX(14px);
  background-color: var(--accent);
  box-shadow: 0 0 8px var(--accent);
}

.slider-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 60%; /* 继续大幅缩短调节条容器宽度，为文字留空间 */
}

.control-value {
  font-family: 'Orbitron', sans-serif;
  font-size: 11px;
  color: var(--accent);
  width: 45px;
  text-align: right;
  flex-shrink: 0;
}

.param-hint {
  font-size: 10px;
  color: var(--text-muted);
  font-style: italic;
}

.cyber-slider {
  flex: 1;
  max-width: 80px; /* 继续限制滑块的最大宽度，使其更短 */
  -webkit-appearance: none;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  outline: none;
}

.cyber-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 12px;
  height: 12px;
  background: var(--accent);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 10px var(--accent);
  transition: all 0.2s ease;
}

.cyber-slider::-webkit-slider-thumb:hover {
  transform: scale(1.2);
  box-shadow: 0 0 15px var(--accent);
}
</style>

